import { Box, BoxProps, Tab, TabProps, Tabs, TabsProps, useTheme } from "@mui/material"
import { blueGrey, grey } from "@mui/material/colors"

type TabType = number | string

interface TabPanelProps extends BoxProps {
    children?: React.ReactNode
    index: TabType
    value: TabType
}

export const NexTabPanel = ({ children, value, index, ...props }: TabPanelProps) => {
    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...props}
        >
            {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
        </Box>
    )
}

export const NexTabs = ({ sx, ...props }: TabsProps) => {
    return (
        <Tabs
            {...props}
            sx={{
                "& .MuiTabs-indicator": {
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: "transparent",
                },
                "& .MuiTabs-indicatorSpan": {
                    maxWidth: "50%",
                    width: "100%",
                    backgroundColor: grey[100],
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            }}
            slotProps={{ indicator: { children: <span className="MuiTabs-indicatorSpan" /> } }}
        />
    )
}

export const NexTab = ({ sx, ...props }: TabProps) => {
    const theme = useTheme()
    return (
        <Tab
            disableRipple={true}
            {...props}
            sx={{
                backgroundColor: theme.palette.primary.main,
                textTransform: "none",
                color: blueGrey[100],
                "&:hover": {
                    color: grey[100],
                    opacity: 1,
                },
                "&.Mui-selected": {
                    color: grey[100],
                    fontWeight: theme.typography.fontWeightMedium,
                },
                "&.Mui-focusVisible": {
                    backgroundColor: "#d1eaff",
                },
                ...(Array.isArray(sx) ? sx : [sx]),
            }}
        />
    )
}
